import {IListView} from "../media/list/ListTypes";
import {BaseConverter} from "../util/string/BaseConverter";
import {listTypeToId} from "../media/list/ListType";
import {MediaTypeUtil} from "../media/MediaType";
import IMediaView from "../media/IMediaView";
import {Format} from "../media/MediaTypes";
import {ServiceHosts} from "../common/ServiceHosts";
import { WidthHeight } from "../types/WidthHeight";

const bcLong = BaseConverter.createLongConverter();
const bcInt = BaseConverter.createIntConverter();

interface IMediaPlayerOptions {
    autoPlay?: boolean;
    isPreview?: boolean;
    loop?: boolean;
    startTime?: number;
    endTime?: number;
}

interface IMediaPlayerFileOptions {
    download?: boolean;
}

interface IListPlayerOptions {
    autoPlay?: boolean;
    isPreview?: boolean;
    loop?: boolean;
}

interface IFilePlayerOptions {
    download?: boolean;
}

// VOD
// https://content-dev.streamhoster.com/mediacontentid/7801/91/1235/1
// https://content-dev.streamhoster.com/embed/media/EZsidd/mhRRoNEXsiV/acLzN1Sesuu_1?preview=1
// live
// https://content-dev.streamhoster.com/mediacontentid/7801/1/50000/5
// https://content-dev.streamhoster.com/embed/media/7801/b/naC_5?preview=1

// https://content-dev.streamhoster.com/embed/media/7801/b/ub_1?preview=1


// direct url (media only)
// https://content-dev.streamhoster.com/file/media/EZsidd/mhRRoNEXsiV/acLzN1Sesuu_1?dl=1

// https://content-dev.streamhoster.com/listcontentid/7801/91/35/1/1
// https://content-dev.streamhoster.com/embed/list/EZsidd/mhRRoNEXsiV/iTU9XHVFdsw_1_1?preview=1

class PlayerLinker {
    protected Delim = "_";
    private HostName: string;
    protected cId: number;
    protected playerId: number;

    constructor(cId: number, playerId: number, isReseller: boolean) {
        this.cId = cId;
        this.playerId = playerId;
        this.HostName = isReseller ? ServiceHosts.content.reseller : ServiceHosts.content.streamhoster;
    }

    private urlEncodeQSArray(qsArray: string[][]): string {
        return qsArray
            .map(qsPair => encodeURIComponent(qsPair[0]) + "=" + encodeURIComponent(qsPair[1]))
            .join("&");
    }

    //<div style="position: relative; padding-bottom: 56.25%; height: 0;">
    // <iframe src="//content.streamhoster.com/player/lv_dptekf2/broadcast1?autoPlay=1&captions=0" frameborder="0" scrolling="no" webkitAllowFullScreen allowFullScreen></iframe></div>

    protected getUrl(uriStem: string, qsArray: string[][]): string {
        const uriWithoutQS = `https://${this.HostName}/${uriStem}`;
        const uriWithQS = qsArray.length > 0 ? `${uriWithoutQS}?${this.urlEncodeQSArray(qsArray)}` : uriWithoutQS;
        return uriWithQS;
    }

    protected getPlayerIframe(url: string, isResponsive: boolean, widthHeight: WidthHeight): string {
        let iframe = '';
        if (isResponsive) {
            const paddingBottom = Math.round((widthHeight.height / widthHeight.width * 100) * 100) / 100;
            iframe += `<div style="position: relative; padding-bottom: ${paddingBottom}%; height: 0;">`;
        }
        iframe += `<iframe src="${url}"`;
        if (isResponsive) {
            iframe += ` style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"`;
        } else {
            iframe += ` width="${widthHeight.width}" height="${widthHeight.height}"`;
        }
        iframe += ` frameborder="0" scrolling="no" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="autoplay; fullscreen;"></iframe>`;
        if (isResponsive)
            iframe += '</div>';
        return iframe;
    }

}

class ListPlayerLinker extends PlayerLinker {

    private list: IListView;

    constructor(cId: number, playerId: number, list: IListView, isReseller) {
        super(cId, playerId, isReseller);
        this.list = list;
    }

    getIframe(isResponsive: boolean, widthHeight: WidthHeight, playerOptions?: IListPlayerOptions): string {
        const url = this.getUrl(
            this.embedUriStem(),
            this.getQSArray(playerOptions));
        return this.getPlayerIframe(url, isResponsive, widthHeight);
    }

    getPreviewUrl(playerOptions?: IMediaPlayerOptions): string {
        return  this.getUrl(
            this.embedUriStem(),
            this.getQSArray(playerOptions));
    }

    private embedUriStem(): string {
        return `embed/list/${this.getUriStem()}`;
    }

    private getUriStem(): string {
        const cIdBC = bcInt.getStr(this.cId);
        const playerIdBC = bcLong.getStr(this.playerId);
        const listIdBC = bcLong.getStr(this.list.data.listId);
        const listTypeId = listTypeToId(this.list.data.listType);
        const mediaTypeId = MediaTypeUtil.getId(this.list.data.mediaType);
        return `${cIdBC}/${playerIdBC}/${listIdBC}${this.Delim}${listTypeId}${this.Delim}${mediaTypeId}`;
    }

    private getQSArray(playerOptions?: IListPlayerOptions): string[][] {
        const qsArray: string[][] = [];
        if (playerOptions) {
            if (playerOptions.autoPlay)
                qsArray.push(["autoPlay", "1"]);
            if (playerOptions.isPreview)
                qsArray.push(["preview", "1"]);
            if (playerOptions.loop)
                qsArray.push(["loop", "1"]);

        }
        return qsArray;
    }

}

class MediaPlayerLinker extends PlayerLinker {

    private media: IMediaView;

    //static PreviewWidthHeight: WidthHeight = {width: 576, height: 432};

    constructor(playerId: number, media: IMediaView, isReseller) {
        super(media.data.media.cId, playerId, isReseller);
        this.media = media;
    }

    getFileUrl(useRefId: boolean, fileOptions?: IMediaPlayerFileOptions): string {
        return this.getUrl(
            this.fileUriStem(useRefId),
            this.getFileQSArray(fileOptions));
    }

    getHlsUrl(useRefId: boolean): string {
        const hlsUriStem = this.hlsUriStem(useRefId);
        const hlsUrl = this.getUrl(hlsUriStem, []);
        return `${hlsUrl}`;
    }

    getCPPreviewIframe(): string {
        return this.getIframe(false, true, {width: 576, height: 324});
    }

    getIframe(useRefId: boolean, isResponsive: boolean, widthHeight: WidthHeight, playerOptions?: IMediaPlayerOptions): string {
        const url = this.getUrl(
            this.embedUriStem(useRefId),
            this.getEmbedQSArray(playerOptions));
        return this.getPlayerIframe(url, isResponsive, widthHeight);
    }

    getPreviewUrl(useRefId: boolean, playerOptions?: IMediaPlayerOptions): string {
        return this.getUrl(
            this.embedUriStem(useRefId),
            this.getEmbedQSArray(playerOptions));
    }

    private embedUriStem(useRefId: boolean): string {
        return `embed/media/${this.getUriStem(useRefId)}`;
    }

    private fileUriStem(useRefId: boolean): string {
        return `link/http/${this.getUriStem(useRefId)}`;
    }

    private hlsUriStem(useRefId: boolean): string {
        return `link/hls/${this.getUriStem(useRefId)}/playlist.m3u8`;
    }

    private getUriStem(useRefId: boolean): string {
        const cIdBC = bcInt.getStr(this.cId);
        const playerIdBC = bcLong.getStr(this.playerId);
        const mediaIdBC = bcLong.getStr(this.media.data.media.mediaId);
        const mediaTypeId = MediaTypeUtil.getId(this.media.data.media.mediaType);
        const nonRefIdUriStem = `${cIdBC}/${playerIdBC}/${mediaIdBC}${this.Delim}${mediaTypeId}`;
        const refId = this.media.data.media.refId || 'missing-refid';
        const refIdUriStem = `${cIdBC}/${playerIdBC}/r/${refId}`;
        return useRefId ? refIdUriStem : nonRefIdUriStem;
    }

    private getEmbedQSArray(playerOptions?: IMediaPlayerOptions): string[][] {
        const qsArray: string[][] = [];
        if (playerOptions) {
            if (playerOptions.autoPlay)
                qsArray.push(["autoPlay", "1"]);
            if (playerOptions.isPreview)
                qsArray.push(["preview", "1"]);
            if (playerOptions.loop)
                qsArray.push(["loop", "1"]);
            if (playerOptions.startTime)
                qsArray.push(["startTime", playerOptions.startTime.toString()]);
            if (playerOptions.endTime)
                qsArray.push(["endTime", playerOptions.endTime.toString()]);
        }
        return qsArray;
    }

    private getFileQSArray(options?: IMediaPlayerFileOptions): string[][] {
        const qsArray: string[][] = [];
        if (options) {
            if (options.download)
                qsArray.push(["dl", "1"]);
        }
        return qsArray;
    }

}


// class MediaPlayerLinker extends PlayerLinker {
//
//     private media: IMediaView;
//
//     //static PreviewWidthHeight: WidthHeight = {width: 576, height: 432};
//
//     constructor(playerId: number, media: IMediaView, isReseller) {
//         super(media.data.media.cId, playerId, isReseller);
//         this.media = media;
//     }
//
//     getFileUrl(fileOptions?: IMediaPlayerFileOptions): string {
//         return this.getUrl(
//             this.fileUriStem(),
//             this.getFileQSArray(fileOptions));
//     }
//
//     getCPPreviewIframe(): string {
//         return this.getIframe(true, {width: 576, height: 324});
//     }
//
//     getIframe(isResponsive: boolean, widthHeight: WidthHeight, playerOptions?: IMediaPlayerOptions): string {
//         const url = this.getUrl(
//             this.embedUriStem(),
//             this.getEmbedQSArray(playerOptions));
//         return this.getPlayerIframe(url, isResponsive, widthHeight);
//     }
//
//     getPreviewUrl(playerOptions?: IMediaPlayerOptions): string {
//         return this.getUrl(
//             this.embedUriStem(),
//             this.getEmbedQSArray(playerOptions));
//     }
//
//     private embedUriStem(): string {
//         return `embed/media/${this.getUriStem()}`;
//     }
//
//     private fileUriStem(): string {
//         return `link/http/${this.getUriStem()}`;
//     }
//
//     private getUriStem(): string {
//         const cIdBC = bcInt.getStr(this.cId);
//         const playerIdBC = bcLong.getStr(this.playerId);
//         const mediaIdBC = bcLong.getStr(this.media.data.media.mediaId);
//         const mediaTypeId = MediaTypeUtil.getId(this.media.data.media.mediaType);
//         return `${cIdBC}/${playerIdBC}/${mediaIdBC}${this.Delim}${mediaTypeId}`;
//     }
//
//     private getEmbedQSArray(playerOptions?: IMediaPlayerOptions): string[][] {
//         const qsArray: string[][] = [];
//         if (playerOptions) {
//             if (playerOptions.autoPlay)
//                 qsArray.push(["autoPlay", "1"]);
//             if (playerOptions.isPreview)
//                 qsArray.push(["preview", "1"]);
//             if (playerOptions.loop)
//                 qsArray.push(["loop", "1"]);
//             if (playerOptions.startTime)
//                 qsArray.push(["startTime", playerOptions.startTime.toString()]);
//             if (playerOptions.endTime)
//                 qsArray.push(["endTime", playerOptions.endTime.toString()]);
//         }
//         return qsArray;
//     }
//
//     private getFileQSArray(options?: IMediaPlayerFileOptions): string[][] {
//         const qsArray: string[][] = [];
//         if (options) {
//             if (options.download)
//                 qsArray.push(["dl", "1"]);
//         }
//         return qsArray;
//     }
//
// }



// embed/media/*
// embed/list/*
// file/media/* (content service selects best media file)

// file/af/cid/playerid/fileId.format
// file/mfrs/cid/playerid/fileId.format
// file/mf/cid/playerid/fileId.format (content service selects specified media file)

class FilePlayerLinker extends PlayerLinker {

    constructor(cId: number, playerId: number, isReseller) {
        super(cId, playerId, isReseller);
    }

    getAccountFileUrl(fileId: number, format: Format, fileOptions?: IFilePlayerOptions): string {
        return this.getUrl(
            this.accountFileUriStem(fileId, format),
            this.getFileQSArray(fileOptions));
    }

    getMediaFileRSUrl(fileId: number, format: Format, fileOptions?: IFilePlayerOptions): string {
        return this.getUrl(
            this.mediaFileRSUriStem(fileId, format),
            this.getFileQSArray(fileOptions));
    }

    getMediaFileUrl(fileId: number, format: Format, fileOptions?: IFilePlayerOptions): string {
        throw new Error(`get media file url Not implemented`);
    }

    private accountFileUriStem(fileId: number, format: Format): string {
        return `file/af/${this.getUriStem(fileId, format)}`;
    }

    private mediaFileRSUriStem(fileId: number, format: Format): string {
        return `file/mfrs/${this.getUriStem(fileId, format)}`;
    }

    private getUriStem(fileId: number, format: Format): string {
        const cIdBC = bcInt.getStr(this.cId);
        const playerIdBC = bcLong.getStr(this.playerId);
        const fileIdBC = bcLong.getStr(fileId);
        return `${cIdBC}/${playerIdBC}/${fileIdBC}.${format}`;
    }

    private getEmbedQSArray(playerOptions?: IMediaPlayerOptions): string[][] {
        const qsArray: string[][] = [];
        if (playerOptions) {
            if (playerOptions.autoPlay)
                qsArray.push(["autoPlay", "1"]);
            if (playerOptions.loop)
                qsArray.push(["loop", "1"]);
            if (playerOptions.startTime)
                qsArray.push(["startTime", playerOptions.startTime.toString()]);
            if (playerOptions.endTime)
                qsArray.push(["endTime", playerOptions.endTime.toString()]);
        }
        return qsArray;
    }

    private getFileQSArray(options?: IMediaPlayerFileOptions): string[][] {
        const qsArray: string[][] = [];
        if (options) {
            if (options.download)
                qsArray.push(["dl", "1"]);
        }
        return qsArray;
    }

}

export {IListPlayerOptions, IMediaPlayerOptions, IMediaPlayerFileOptions, FilePlayerLinker, ListPlayerLinker, MediaPlayerLinker}